import { ApprovalsService } from 'api-clients/monolith';

/**
 * Derived from the generated client rather than hand-written.
 *
 * The rule tree is wide (levels → approvers → backup approvers) and every field
 * on it is optional in the OpenAPI document, so a hand-maintained mirror would
 * disagree with the server the first time a field is added and nothing would
 * fail to compile. Deriving means a contract change lands as a type error here.
 */
type RulesResponse = Awaited<
  ReturnType<typeof ApprovalsService.getInternalApiApprovalsRules>
>;

export type ApprovalRule = NonNullable<RulesResponse['rules']>[number];
export type ApprovalRuleLevel = NonNullable<ApprovalRule['levels']>[number];
export type ApprovalRuleApprover = NonNullable<
  ApprovalRuleLevel['approvers']
>[number];

/**
 * The editor's Offers | Openings toggle. One entity-agnostic rule table backs
 * both, so this is a filter over one list rather than two features.
 */
export type SubjectType = NonNullable<ApprovalRule['subject_type']>;

export const OFFER: SubjectType = 'OfferLetter';
export const OPENING: SubjectType = 'Funnel';
